/**
 * Fotos de fundo do mapa de aplicação (módulo `application_map`).
 *
 * São anexos do paciente (núcleo `patient_attachments`) com
 * context = 'application_map', kind = 'image' e, em `meta`, a vista para a
 * qual a foto foi tirada: { "view": "face" | "front" | "back" }. O contexto é
 * próprio do mapa: essas fotos não aparecem em Fotos de evolução nem em Anexos.
 *
 * Funções puras, usadas pelo popup de escolha da foto.
 */

import dayjs from 'dayjs';
import { applicationViewLabel } from './applicationFigures';

export const APPLICATION_PHOTO_CONTEXT = 'application_map';

export function filterApplicationPhotos(attachments) {
  return (attachments || []).filter((item) => item && item.context === APPLICATION_PHOTO_CONTEXT);
}

export function getPhotoView(photo) {
  return (photo && photo.meta && photo.meta.view) || '';
}

export function applicationPhotoLabel(photo) {
  const view = getPhotoView(photo);
  return view ? applicationViewLabel(view) : 'Sem vista';
}

export function formatApplicationPhotoDate(photo) {
  return photo && photo.documentDate ? dayjs(photo.documentDate).format('DD/MM/YYYY') : '';
}

/** Campos extras do upload de uma foto tirada para a vista `view`. */
export function buildApplicationPhotoFields(view) {
  return {
    meta: JSON.stringify({ view }),
    title: `Foto da vista ${applicationViewLabel(view)}`,
    note: '',
  };
}

/** Fotos da vista primeiro; dentro de cada grupo, a mais recente. */
export function sortPhotosForView(photos, view) {
  return (photos || []).slice().sort((a, b) => {
    const matchA = getPhotoView(a) === view ? 0 : 1;
    const matchB = getPhotoView(b) === view ? 0 : 1;
    if (matchA !== matchB) return matchA - matchB;
    const dateA = a.documentDate || '';
    const dateB = b.documentDate || '';
    if (dateA !== dateB) return dateA < dateB ? 1 : -1;
    return Number(b.id) - Number(a.id);
  });
}
